import { OptionalMaybe } from "../../../../../../api/types/generated-types";

export const getRequiredLabel = (boolean: OptionalMaybe<boolean>): string => {
  return boolean ? "Required" : "Not required";
};
